
import { computed, defineComponent, PropType } from 'vue'

// Components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// Types
import { CourierReportT } from '@/core/types/dispatcher.types'

// Composable
import useAccount from '@/common/composable/useAccount'

export default defineComponent({
    components: {
        TheButton,
    },
    props: {
        item: {
            type: Object as PropType<CourierReportT>,
            required: true,
        },
        completeLoading: {
            type: Boolean,
            default: false,
        },
        completeDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['complete-day'],
    setup(props, { emit }) {
        const { havePermissions } = useAccount()

        const isCanComplete = computed(() => {
            if (havePermissions(['couriers-close-day', 'all-root-permission'])) return true
            return false
        })

        const emitComplete = () => {
            if (props.completeLoading || props.completeDisabled) return
            emit('complete-day', { ...props.item })
        }

        return { isCanComplete, emitComplete }
    },
})
